import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import validateZipcode from './validator';
import { FormGroup } from '../../../common-components';
import { clearRegistrationBackendError } from '../../data/actions';

/**
 * Zipcode field wrapper. It handles validation for a 5-digit integer zipcode.
 */
const ZipcodeField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const validationApiRateLimited = useSelector(state => state.register.validationApiRateLimited);

  const { handleErrorChange } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const fieldError = validateZipcode(value, formatMessage);
    if (fieldError) {
      handleErrorChange('zip_code', fieldError);
    } else if (!validationApiRateLimited) {
      // You may want to dispatch some other action related to zipcode if necessary
    }
  };

  const handleOnFocus = () => {
    handleErrorChange('zip_code', '');
    dispatch(clearRegistrationBackendError('zip_code'));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

ZipcodeField.defaultProps = {
  errorMessage: '',
};

ZipcodeField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default ZipcodeField;
